import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';

// Rich overflow menu row (icon tile + title + description), mirroring the
// campaign card menu. item: {icon, color, bg, label, desc, danger}.
const MenuRow = ({ icon, color, bg, label, desc, danger, onClick }) => (
  <div className="pux-selbar-menu-item" onClick={onClick}
       style={{ display:'flex', alignItems:'center', gap:12, padding:'9px 10px', borderRadius:10, cursor:'pointer' }}>
    <span style={{ width:34, height:34, borderRadius:9, background:bg, color:color, flexShrink:0,
                   display:'flex', alignItems:'center', justifyContent:'center' }}>
      <i className={icon} style={{ fontSize:'1.05rem' }} />
    </span>
    <span style={{ display:'flex', flexDirection:'column', minWidth:0, lineHeight:1.25 }}>
      <span style={{ fontWeight:600, fontSize:'.9rem', color: danger ? '#dc2626' : '#111827' }}>{label}</span>
      {desc && <span style={{ fontSize:'.74rem', color:'#9ca3af' }}>{desc}</span>}
    </span>
  </div>
);

// Appears only when rows are selected. primaryActions: [{key,label,icon,command,className}].
// overflowItems: [{label,desc,icon,color,bg,command,danger} | {separator:true}].
export default function ProductSelectionBar({ t, count, primaryActions, overflowItems, onClear }) {
  const menu = useRef(null);
  if (!count) return null;
  const items = (overflowItems || []).filter(Boolean);
  return (
    <div className="pux-selbar">
      <strong>{t('product.selected_count', { count })}</strong>
      {primaryActions.map(a => (
        <Button key={a.key} label={a.label} icon={a.icon}
                className={`p-button-sm ${a.className || 'p-button-outlined'}`} onClick={a.command} />
      ))}
      {items.length > 0 && (
        <>
          <Button label={t('actions.more')} icon="pi pi-ellipsis-v" className="p-button-text p-button-sm" onClick={(e) => menu.current.toggle(e)} />
          <OverlayPanel ref={menu} className="pux-selbar-menu" style={{ width:'19em' }}>
            <style>{`.pux-selbar-menu .p-overlaypanel-content{padding:8px}.pux-selbar-menu .pux-selbar-menu-item{transition:background .12s}.pux-selbar-menu .pux-selbar-menu-item:hover{background:#f3f4f6}`}</style>
            <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
              {items.map((it, i) => it.separator
                ? <div key={`sep${i}`} style={{ borderTop:'1px solid #f0f0f0', margin:'6px 4px' }} />
                : <MenuRow key={(it.label || '') + i} {...it}
                           onClick={() => { menu.current.hide(); it.command && it.command(); }} />)}
            </div>
          </OverlayPanel>
        </>
      )}
      <span style={{ flex: 1 }} />
      <Button label={t('actions.clear_selection')} className="p-button-text p-button-sm" onClick={onClear} />
    </div>
  );
}
